
import { supabase } from "@/integrations/supabase/client";
import { RecurringTask } from "./types";

export const fetchRecurringTasks = async (
  userId: string, 
  brandId: string
): Promise<RecurringTask[]> => {
  // Get ALL squad members for the current user in this brand
  const { data: squadData, error: squadError } = await supabase
    .from('growth_squad')
    .select('id')
    .eq('user_id', userId)
    .eq('brand_id', brandId);

  if (squadError) {
    console.error('Error fetching squad data:', squadError);
    throw squadError;
  }

  // If no squad members, return empty array
  if (!squadData || squadData.length === 0) {
    return [];
  }

  // Extract all squad IDs
  const squadIds = squadData.map(squad => squad.id);

  const { data, error } = await supabase
    .from('recurring_tasks')
    .select(`
      *,
      growth_sprints!recurring_tasks_sprint_id_fkey (
        id,
        name
      ),
      brands (
        name,
        slug
      ),
      os_tasks_projects!fk_recurring_tasks_project_id (
        id,
        name,
        description,
        icon
      )
    `)
    .in('assigned_to', squadIds)
    .eq('brand_id', brandId)
    .eq('is_deleted', false)
    .order('created_at', { ascending: false });

  if (error) throw error;
  
  const tasksWithSprint = (data || []).map(task => ({
    ...task,
    sprint: task.growth_sprints ? {
      id: task.growth_sprints.id,
      name: task.growth_sprints.name
    } : undefined,
    brands: task.brands ? {
      name: task.brands.name,
      slug: task.brands.slug
    } : undefined
  }));
  
  return tasksWithSprint;
};

export const deleteRecurringTask = async (taskId: string): Promise<void> => {
  const { error } = await supabase
    .from('recurring_tasks')
    .update({ is_deleted: true })
    .eq('id', taskId);

  if (error) throw error;
};
